import { toast } from "react-toastify";
import { getAccessToken } from "../../utils/okta-config";
import { API_ROOT, REST_URL } from "../../constants/constants";
import { log } from "../../Helper";

export async function AuditTableData() {
    const notifySuccess = (message) => {
      toast.success(message);
    };
  
    try {
      let url =
        `${process.env.REACT_APP_API_ENDPOINT}/compliance/getComplianceData`;
  
        const requestOptions = {
          method: "GET",
          headers: {
              Authorization: `Bearer ${getAccessToken()}`,
              "Access-Control-Allow-Origin": API_ROOT,
          },
      };
  
      const response = await fetch(url, requestOptions);

  
      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }
      const result = await response.json();
      log('compliance data-- ',  result);
      return result;
    } catch (error) {
      log('error in calling API--', error);
    }
  }